import React, { useEffect, useRef } from 'react';

const HeroAnimation = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        // Set size
        const resizeCanvas = () => {
            const container = canvas.parentElement;
            if (container) {
                canvas.width = container.clientWidth;
                canvas.height = container.clientHeight;
            }
        };

        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        const isMobile = window.innerWidth <= 768;
        const nodes = [];
        const nodeCount = isMobile ? 30 : 50;
        const connectionDistance = isMobile ? 100 : 150;

        for (let i = 0; i < nodeCount; i++) {
            nodes.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                radius: Math.random() * 2 + 1,
                vx: (Math.random() - 0.5) * 0.5,
                vy: (Math.random() - 0.5) * 0.5,
                color: '#7c3aed'
            });
        }

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.lineWidth = 0.5;

            for (let i = 0; i < nodes.length; i++) {
                for (let j = i + 1; j < nodes.length; j++) {
                    const dx = nodes[i].x - nodes[j].x;
                    const dy = nodes[i].y - nodes[j].y;
                    const distance = Math.sqrt(dx * dx + dy * dy);

                    if (distance < connectionDistance) {
                        ctx.beginPath();
                        ctx.moveTo(nodes[i].x, nodes[i].y);
                        ctx.lineTo(nodes[j].x, nodes[j].y);
                        const opacity = 1 - distance / connectionDistance;
                        ctx.strokeStyle = `rgba(124, 58, 237, ${opacity * 0.5})`;
                        ctx.stroke();
                    }
                }
            }

            for (let node of nodes) {
                ctx.beginPath();
                ctx.arc(node.x, node.y, node.radius, 0, Math.PI * 2);
                ctx.fillStyle = node.color;
                ctx.fill();

                if (node.radius > 2.5) {
                    ctx.beginPath();
                    ctx.arc(node.x, node.y, node.radius * 2, 0, Math.PI * 2);
                    const gradient = ctx.createRadialGradient(
                        node.x, node.y, node.radius,
                        node.x, node.y, node.radius * 2
                    );
                    gradient.addColorStop(0, 'rgba(124, 58, 237, 0.3)'); // Purple glow core
                    gradient.addColorStop(1, 'rgba(124, 58, 237, 0)');   // Fades to transparent
                    ctx.fillStyle = gradient;
                    ctx.fill();
                }

                node.x += node.vx;
                node.y += node.vy;

                if (node.x < 0 || node.x > canvas.width) node.vx *= -1;
                if (node.y < 0 || node.y > canvas.height) node.vy *= -1;
            }

            requestAnimationFrame(animate);
        };

        animate();

        return () => {
            window.removeEventListener('resize', resizeCanvas);
        };
    }, []);

    return (
        <div
            style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(to right, rgba(124,58,237,0.08), rgba(139,92,246,0.08))',
                zIndex: 0,
                pointerEvents: 'none'
            }}
        >
            <canvas
                ref={canvasRef}
                style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%'
                }}
            />
        </div>
    );
};

export default HeroAnimation;
